import * as React from 'react';
import * as Glob from '../../Globale';
import * as Dati from '../../Dati';
import * as Data from '../../Data';
import { Polar } from 'react-chartjs-2';
import { ChiamaAPI, Trad } from '../';
import { BasePureComponent } from '../BaseComponent';
import * as Dashboard from './Dashboard';

interface IDashboardProdottiFideAffidamentoProps {
    ID_FideAffidamento: number;
}

interface IDashboardProdottiFideAffidamentoState {
    Aggiorna: number
}

export class DashboardProdottiFideAffidamento extends BasePureComponent<IDashboardProdottiFideAffidamentoProps, IDashboardProdottiFideAffidamentoState> {
    private _Dati: Dati.ChartData = new Dati.ChartData();
    private _ID_FideAffidamento: number = 0;

    public constructor(props: any) {
        super(props);
        this.state = { Aggiorna: 1 };
    }

    private Inizialize(props: IDashboardProdottiFideAffidamentoProps): void {
        this._ID_FideAffidamento = this.props.ID_FideAffidamento != undefined ? this.props.ID_FideAffidamento : 0;
    }

    private OnRisProdottiEmessi(sender: ChiamaAPI, dati: Dati.CRisAPIDato<Dati.ChartData>, datiNuovi: boolean): React.ReactNode {
        this._Dati = dati.Dato;

        //Traduzione etichette
        for (let x: number = 0; x < this._Dati.labels.length; x++) {
            this._Dati.labels[x] = Trad.Trad(this._Dati.labels[x]);
        }

        //Imposto i dati dei colori
        for (let x: number = 0; x < this._Dati.datasets.length; x++) {
            this._Dati.datasets[x].backgroundColor = [];
            this._Dati.datasets[x].borderColor = [];
            for (let i: number = 0; i < this._Dati.datasets[x].data.length; i++) {
                this._Dati.datasets[x].backgroundColor.push(Glob.ColoreStaticA(i));
                this._Dati.datasets[x].borderColor.push(Glob.ColoreStaticA(i));
                this._Dati.datasets[x].borderWidth = 1;
            }
        }
        return <Polar data={this._Dati} />;
    }

    componentDidMount() {
        setInterval(() => { this.setState({ Aggiorna: this.state.Aggiorna + 1 }) }, Dashboard.SecondsAutomaticUpdate * 1000);
    }

    public render() {
        this.Inizialize(this.props);

        return <div className={Glob.DimensioneCSS(6)}>
            <div className={Glob.DimensioneCSS(6)}>
                <div className="kt-portlet kt-portlet--full-height">
                    <div className="kt-portlet__head">
                        <div className="kt-portlet__head-label">
                            <div className="kt-portlet__head-label">
                                <h3 className="kt-portlet__head-label">
                                    {Trad.Trad("ProdottiAffidamento")}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__body">
                        <ChiamaAPI Aggiornare={this.state.Aggiorna}
                            URL={"/api/Polizza/ProdottiEmessiFideAffidamento?ID_FideAffidamento=" + this._ID_FideAffidamento}
                            OnRis={(s, d, dn) => this.OnRisProdottiEmessi(s, d, dn)}
                            OnErrore={this.OnErrore} />
                    </div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Dashboards/DashboardProdottiFideAffidamento.tsx